<section id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>{{ lang.deadlines }}</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>{{ lang.deadlines }}</li>
        </ul>
      </div> 
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body deadline-name" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <div class="row p-10">

                  <div class="col-sm-2">
                    <div class="social-icons">
                      
                      <a class="plus-add toottip" (click)="add()" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Add">
                        <i class="fa fa-plus"></i>
                      </a>

                      <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                          data-options="splash-2 splash-ef-4" title="Export">
                        <span class="glyphicon glyphicon-export"></span>
                      </a>

                      <a class="plus-import" data-toggle="modal" data-target="#datatableExport2" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Import">
                        <span class="glyphicon glyphicon-import"></span>
                      </a>

                      <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id="" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Duplicate">
                        <span class="glyphicon glyphicon-file"></span>
                      </a>
                      
                      
                      <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'" title="Erase">
                        <span class="glyphicon glyphicon-trash"></span>
                      </a>

                    </div>
                  </div>

                  <div class="col-sm-2">
                    <select class="form-control" (change)="datatableFilterAction()" [(ngModel)]="filter1">
                        <option value>{{ lang.selectType }}</option>
                        <option value="{{ lang.quality }}">{{ lang.quality }}</option>
                        <option value="{{ lang.safety }}">{{ lang.safety }}</option>
                        <option value="{{ lang.environment }}">{{ lang.environment }}</option>
                        <option value="{{ lang.administration }}">{{ lang.administration }}</option>
                        <option value="{{ lang.various }}">{{ lang.various }}</option>
                    </select>
                  </div>

                  <div class="col-sm-2">
                    <select class="form-control" (change)="datatableFilterAction()" [(ngModel)]="filter2" name="status_change"  data-column="17" >
                      <option value>{{ lang.selectStatus }}</option>
                      <option value="1">{{ lang.all }}</option>
                      <option value="2">{{ lang.expired }}</option>
                      <option value="3">{{ lang.notExpired }}</option>
                    </select>
                  </div>

                  <div class="col-sm-2">
                    <div class="social-icons">
                      
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>

                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>

                    </div>
                  </div>

                </div>

                <div class="table-responsive" style="overflow: auto;">
    
                  <table datatable [dtOptions]="datatableOptions1" [dtTrigger]="dtTrigger"  class="table-striped table-sm row-border hover" id="table1" *ngIf="records">
                    <thead>
                      <tr>
                        <th>Hidden.No</th>
                        <th>
                          <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                            <input type="checkbox"><i></i>
                          </label>
                        </th>
                        <th>No.</th>
                        <th>{{ lang.type }}</th>
                        <th>{{ lang.description }}</th>
                        <th>{{ lang.renewalNote }}</th>
                        <th>{{ lang.created }}</th>
                        <th>{{ lang.lastAction }}</th>
                        <th>{{ lang.referringDate }}</th>
                        <th>{{ lang.repeatingPeriod }}</th>
                        <th>{{ lang.nextDeadline }}</th>
                        <th>{{ lang.daysleft }}</th>
                        <th></th>
                        <th>{{ lang.action }}</th>
                        <th style="display: none;">{{ lang.attachments }}</th>
                      </tr>
                    </thead>

                    <tbody dragula="records" [(dragulaModel)]="records">
                      <tr *ngFor="let record of records let i = index" id="{{record.timetabelId}}">
                        <td>{{i+1}}</td>
                        <td></td>
                        <td>{{i+1}}</td>
                        <td>{{record.timetable_type}}</td>
                        <td><a [routerLink]="['/'+AppFrontRoutes.DEADLINE_VIEW+'/'+record.timetabelId]">{{record.timetable_discrption}}</a></td>
                        <td>{{record.timetable_renewal_notes}}</td>
                        <td>{{record.timetable_added_date | timeConverter : 'dd-MM-yyyy'}}</td>
                        <td>{{record.last_action}}</td>
                        <td>{{record.referring_date}}</td>
                        <td>{{record.period}}</td>
                        <td>{{record.next_deadline}}</td>
                        <td [style.color] = "record.days_left > 0 ? 'green' : 'red'">{{ record.days_left }}</td>
                        <td>
                          <div *ngIf="record.period != '-';then content else other_content"></div>
                          <ng-template #content> <a (click)="pause(record.timetabelId)"><i class="fa fa-pause"></i></a></ng-template>

                          <ng-template #other_content> <a (click)="play(record.timetabelId,record.occ_details)"><i class="fa fa-play"></i></a></ng-template>
                          
                        <td>
                          <div class="btn-group dropup">
                            
                            <button type="button" class="btn btn-info dropdown-toggle circle_btn" data-toggle="dropdown"
                              aria-expanded="false"><i class="fa fa-tasks"></i></button>

                            <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                              <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(record.timetabelId)"><i class="fa fa-trash"></i> {{ lang.erase }}</a></li>
                              <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="view_action" (click)="duplicate(record.timetabelId)"><i class="fa fa-files-o fa-fw text-red"></i> {{ lang.duplicate }}</a></li>
                              <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="edit_action" (click)="edit(record.timetabelId)"><i class="fa fa-edit"></i> {{ lang.modify }}</a></li>
                              <!-- <li><a class="view_action" (click)="view(record.timetabelId)"><i class="glyphicon glyphicon-eye-open"></i> {{ lang.view }}</a></li> -->
                              <li><a [routerLink]="['/'+AppFrontRoutes.DEADLINE_VIEW+'/'+record.timetabelId]" class="blue_action"><i class="glyphicon glyphicon-eye-open"></i> {{lang.view}}</a></li>

                            </ul>
                          </div>
                        </td>

                        <td style="display: none;">{{record.timetable_name}}</td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>

              <div role="tabpanel" *ngSwitchCase="'calendar'">

                <div class="row p-10">

                  <div class="col-sm-9">
                  </div>

                  <div class="col-sm-3">
                    <div class="social-icons">
                      <a class="plus-export" (click)="setPageView('list')">
                        <span class="glyphicon glyphicon-list"></span>
                      </a>
                      <a class="plus-export" (click)="setPageView('calendar')">
                        <span class="glyphicon glyphicon-calendar"></span>
                      </a>
                    </div>
                  </div>

                </div>

                <app-deadline-calendar></app-deadline-calendar>
              </div>
            
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>



<div class="modal splash fade" id="datatableExport1" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">
  
      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.selectColumns }}</h3>
      </div>

      <div class="modal-body column_export">
        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{ lang?.selectAll }} </label>
        </div>
        <div class="row flexs">

          <div class="active-left">
            <h2>{{ lang?.activeColumns }}</h2>

            <div class="row" *ngFor="let option of datatableCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

          <div class="active-left">
            <h2>{{ lang?.additionalColumns}}</h2>

            <div class="row" *ngFor="let option of datatableAddCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>

        </div>

      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn1" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
      </div>

    </div>
  </div>
</div>

<div class="modal splash fade" id="datatableExport2" tabindex="-1" role="dialog" aria-hidden="true">
<div class="modal-dialog">
    <div class="modal-content">
      <!-- <div class="modal-header">
        <h3 class="modal-title custom-font">IMPORT HOURLY DATA</h3>
        <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
    
      </div>
       -->
       <div class="modal-header">
        <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{ lang?.importTimetabledata }}</h4>
        <button type="button" class="close pull-right"  data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      
      <div class="modal-body column_export">
        <div class="row"> 
          <input type="file" class="filestyle" id="file" name='file'  data-buttonText="Choose file" (change)="onPhotoPickerChange($event)" appFileDesign>

          <font style="vertical-align: inherit;"><font style="vertical-align: inherit;"><a href="http://vmi313621.contaboserver.net/Software_backend/uploads/csv_files/template_timetable.csv" download="">{{ lang?.todownloadtocsv}}</a></font></font>  
      </div>  
      </div>

      <div class="modal-footer">
        <div id="datatableExportBtn2" class="export_dynamic_btn">
        </div>
          <button type="button" class="btn btn-primary" (click)="onclick()">{{ lang?.save }}</button>
        <!-- <button class="btn btn-warning" data-dismiss="modal">Close</button>-->
        <button type="button" class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>

      </div>
    </div>
  </div>
</div>

<div class="modal splash fade" id="sactivate_plan" tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{ lang?.enterStartdate }}</h3>
      </div>

      <form #user="ngForm" (ngSubmit)="onSubmit(user.value)">
        <div class="modal-body column_export">
          <input type="date" class="form-control" name="start_date" id="start_date" value="" ngModel required>
          <input type="hidden" name="deadline_id" id="deadline_id" ngModel="{{ tid }}">
          <input type="hidden" name="occurrence_id" id="occurrence_id" ngModel="{{ oid  }}">
          <input type="hidden" name="pid" id="pid" ngModel="1">
        </div>

        <div class="modal-footer">
          <div id="datatableExportBtn1" class="export_dynamic_btn">
          </div>
          <button class="btn btn-success">{{ lang?.submit }}</button>
          <button class="btn btn-warning" data-dismiss="modal">{{ lang?.close }}</button>
        </div>
      </form>

    </div>
  </div>
</div>

